// extracted by mini-css-extract-plugin
export var acceptButton = "_3u-5";
export var fullContent = "_3u-4";
export var link = "_3u-6";
export var linkIcon = "_3u-7";
export var sideContent = "_3u-3";
export var sideImage = "_3u-2";
export var sideImageWrapper = "_3u-1";
export var splitLayout = "_3u-0";